import { useSelector } from 'react-redux';
import { selectTitleCheckError, selectTitleCheckLoadingState, selectTitleCheckResponse } from '../../redux-state/selectors';

function TitleOutputRightSide() {
  const titleCheckResponse = useSelector(selectTitleCheckResponse);
  const isLoading = useSelector(selectTitleCheckLoadingState);
  const error = useSelector(selectTitleCheckError);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  if (!titleCheckResponse) {
    return <div>No data available</div>;
  }

  const { vehicle_interests_section, title_info, past_title_info, lien_info, ebay_auctions, brand_info, impound_info, theft_info } = titleCheckResponse;

  return (
    <div className="flex flex-col w-[100%]">
      <div className="flex flex-col w-[100%]">
        {vehicle_interests_section && Object.keys(vehicle_interests_section).length > 0 && (
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Vehicle Interests
            </div>

            <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-24">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {vehicle_interests_section?.title_owner &&
                  <div className="flex flex-row justify-between">
                    <div>
                      Title Owner:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.title_owner}
                    </div>
                  </div>
                }

                {vehicle_interests_section?.title_owner_address &&
                  <div className="flex flex-row justify-between">
                    <div>
                      Title Owner Address:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.title_owner_address}
                    </div>
                  </div>
                }

                
                  <div className="flex flex-row justify-between">
                    <div>
                      Has Lienholder:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.has_lien_holder ? 'True' : 'False'}
                    </div>
                  </div>

                {vehicle_interests_section?.lien_date &&
                  <div className="flex flex-row justify-between">
                    <div>
                      Lien Date:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.lien_date}
                    </div>
                  </div>
                }

                {vehicle_interests_section?.lien_holder_name &&
                  <div className="flex flex-row justify-between">
                    <div>
                      Lienholder Name:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.lien_holder_name}
                    </div>
                  </div>
                }

                {vehicle_interests_section?.lien_holder_address &&
                  <div className="flex flex-row justify-between">
                    <div>
                      Lienholder Address:
                    </div>
                    <div className="font-medium">
                      {vehicle_interests_section?.lien_holder_address}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        )}

        <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
            Current Title Information
          </div>

          <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-24">
            <div className="flex flex-col w-[100%] text-gray-700 gap-2">
              {title_info?.title_number &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Number:
                  </div>
                  <div className="font-medium">{title_info?.title_number}</div>
                </div>
              }

              {title_info?.title_issue_state &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Issue State:
                  </div>
                  <div className="font-medium">{title_info?.title_issue_state}</div>
                </div>
              }

              {title_info?.has_brands &&
                <div className="flex flex-row justify-between">
                  <div>
                    Brands Check:
                  </div>
                  <div className="font-medium">{title_info?.has_brands}</div>
                </div>
              }

              {title_info?.title_issue_date &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Issue Date:
                  </div>
                  <div className="font-medium">{title_info?.title_issue_date}</div>
                </div>
              }

              {title_info?.vehicle_odometer_reading &&
                <div className="flex flex-row justify-between">
                  <div>
                    Vehicle Odometer Reading:
                  </div>
                  <div className="font-medium">{title_info?.vehicle_odometer_reading}</div>
                </div>
              }
            </div>
          </div>
        </div>

        {past_title_info && past_title_info.length > 0 &&
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Past Title Information
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {past_title_info && past_title_info.length > 0 ? (
                  past_title_info.map((title, index) => (
                    <div key={index}>
                      {title?.title_issue_state &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Title Issue State:
                          </div>
                          <div className="font-medium">{title?.title_issue_state}</div>
                        </div>
                      }

                      {title?.title_issue_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Title Issue Date:
                          </div>
                          <div className="font-medium">{title?.title_issue_date}</div>
                        </div>
                      }

                      {title?.vehicle_odometer_reading &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Vehicle Ododmeter Reading:
                          </div>
                          <div className="font-medium">{title?.vehicle_odometer_reading}</div>
                        </div>
                      }

                      {index < past_title_info.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }

        {lien_info && lien_info.length > 0 &&
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Lien Information
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {lien_info && lien_info.length > 0 ? (
                  lien_info.map((lien, index) => (
                    <div key={index}>
                      {lien?.lien_holder &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Lien Holder:
                          </div>
                          <div className="font-medium">{lien?.lien_holder}</div>
                        </div>
                      }

                      {lien?.lien_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Lien Date:
                          </div>
                          <div className="font-medium">{lien?.lien_date}</div>
                        </div>
                      }

                      {index < lien_info.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }


        {brand_info && brand_info.length > 0 &&
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Brand Reports
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {brand_info && brand_info.length > 0 ? (
                  brand_info.map((brand, index) => (
                    <div key={index}>
                      {brand?.re_state &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Reporting State:
                          </div>
                          <div className="font-medium">{brand?.re_state}</div>
                        </div>
                      }

                      {brand?.branding &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Branding:
                          </div>
                          <div className="font-medium">{brand?.branding}</div>
                        </div>
                      }

                      {brand?.branding_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Branding Date:
                          </div>
                          <div className="font-medium">{brand?.branding_date}</div>
                        </div>
                      }

                      {index < brand_info.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }

        {theft_info && theft_info.length > 0 &&
        <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
            Theft Reports
          </div>

          <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
            <div className="flex flex-col w-[100%] text-gray-700 gap-2">
              {theft_info && theft_info.length > 0 ? (
                theft_info.map((theft, index) => (
                  <div key={index}>
                    {theft?.last_event_date &&
                      <div className="flex flex-row justify-between">
                        <div>
                          Last event date:
                        </div>
                        <div className="font-medium">{theft?.last_event_date}</div>
                      </div>
                    }

                    {theft?.state &&
                      <div className="flex flex-row justify-between">
                        <div>
                          State:
                        </div>
                        <div className="font-medium">{theft?.state}</div>
                      </div>
                    }

                    {theft?.status &&
                      <div className="flex flex-row justify-between">
                        <div>
                          Status:
                        </div>
                        <div className="font-medium">{theft?.status}</div>
                      </div>
                    }

                    {index < theft_info.length - 1 && (
                      <div className="border-t-2 border-t-gray-100 my-4"></div>
                    )}
                  </div>
                ))
              ) : (
                <div>No Brands Report Available</div>
              )}
            </div>
          </div>
        </div>
        }

        {impound_info && impound_info.length > 0 &&
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Impound Information
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {impound_info && impound_info.length > 0 ? (
                  impound_info.map((impound, index) => (
                    <div key={index}>
                      {impound?.state &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Impound State:
                          </div>
                          <div className="font-medium">{impound?.state}</div>
                        </div>
                      }

                      {impound?.impound_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Impound Date:
                          </div>
                          <div className="font-medium">{impound?.impound_date}</div>
                        </div>
                      }

                      {index < impound_info.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }

          {ebay_auctions && ebay_auctions.length > 0 &&
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Ebay Auctions
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {ebay_auctions && ebay_auctions.length > 0 ? (
                  ebay_auctions.map((auction, index) => (
                    <div key={index}>
                      {auction?.auction_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Auction Date:
                          </div>
                          <div className="font-medium">{auction?.auction_date}</div>
                        </div>
                      }

                      {auction?.item_number &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Item Number:
                          </div>
                          <div className="font-medium">{auction?.item_number}</div>
                        </div>
                      }

                      {index < ebay_auctions.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }


      </div>
    </div>
  );
}

export default TitleOutputRightSide;
